export enum LanguageEnum {
  ENInternational = 'ENInternational',
  EN = 'EN', // english
  DE = 'DE', // german
  IT = 'IT', // italian
  FR = 'FR', // french
  DUMMY = 'DUMMY'
}
